// WOW
new WOW().init();

// IE 11 closest to work
(function(ELEMENT) {
	ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
	ELEMENT.closest = ELEMENT.closest || function closest(selector) {
		if (!this) return null;
		if (this.matches(selector)) return this;
		if (!this.parentElement) {return null}
			else return this.parentElement.closest(selector)
		};
}(Element.prototype));


// Slider with arrows
let sliderWithCounter = function(classlist, name) {
    let $slider = $(classlist);

    if ($slider.length) {
        var currentSlide;
        var slidesCount;
        var sliderCounter = document.querySelector(`${classlist}-counter`);
        
        var updateSliderCounter = function(slick, currentIndex) {
            currentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = slick.slideCount;
            $(sliderCounter).html(`
                <div class="slide-counter__current ${name}-counter__current">${currentSlide}</div>
                <div class="slide-counter__line ${name}-counter__line"></div>
                <div class="slide-counter__total ${name}-counter__total">${slidesCount}</div>
            `)
        };
    
        $slider.on('init', function(event, slick) {
        $slider.append(sliderCounter);
            updateSliderCounter(slick);
        });
    
        $slider.on('afterChange', function(event, slick, currentSlide) {
            updateSliderCounter(slick, currentSlide);
        });
    
        $slider.slick({
            arrows: true,
            dots: false,
            infinite: false,
            slidesToShow: 1,
        });
    }
}